define([
	"dojo/_base/declare",
	"dojo/store/util/QueryResults",
	"dojo/when",
	"lodash",
	"src/c8-platform/service/aggregateStoreService",
	"csi",
	"csi/comm",
	"csi/locale",
	"csi/reflection",
	"csi/store/_base",
	"csi/store/Cache",
	"csi/store/GroupQueryEngine",
	"csi/xml",
	"csi/xml/Query",
	"./_RequestQueryMixin",
	"./Request",
	"./common"
], function(declare, QueryResults, when, _,
	{getAggregateResponseGroupById, getAggregateResponseNodeType, isAggregateStoreResponseEmpty, isAggregateStoreResponseGrouped},
	csi, comm, locale, reflection, csiStore, StoreCache, GroupQueryEngine, xml, Query, _RequestQueryMixin, RequestStore,
	{
		assignItemIndex,
		createEmptyGroupItem,
		DISABLED_PROPERTY,
		EMPTY_GROUP_ITEM_PROPERTY,
		getNamesFromAggregateStoreResponse,
		getLocalizedGroupLabel,
		getLocalizedGroupLabelOld,
		getNamesResultItemCss,
		INVALID_PROPERTY,
		mapResultsToGroupItems
	}
) {

	const ACTION_PROPERTY = "action";
	const CSS_PROPERTY = "css";
	const ID_PROPERTY = "$";
	const INDEX_PROPERTY = "index";
	const NAME_PROPERTY = "Name";
	const SEARCH_PROPERTY = "search";

	// priority items grouping
	const GROUP_SUGGESTED = "Suggested";
	const GROUP_ALL_ITEMS = "All Items";

	// group sorting weights
	const GROUP_INDEX_OTHER = -1;
	const GROUP_INDEX_MAP = {
		[GROUP_SUGGESTED]: 1,
		[GROUP_ALL_ITEMS]: 2,
	};

	var _Names = declare([RequestStore, _RequestQueryMixin], {
		queryClass: Query,
		requestBinaryParameter: comm.QUERY_XML,
		//		requestModule: comm.MOD_SEARCH,
		requestOperation: "NamesByXML",

		/** @property {Action} action - action used to Go to Dialog */
		//action: null,

		// Object[]: data representing actions to appear at end of list
		//actionData: null,

		/** @property {Record<string, number>} aggregateGroupIndexMap - map from aggregate group id to index in response */
		//aggregateGroupIndexMap: null,

		/** @property {IAggregateStoreParams} aggregateStoreParams - unique identifier for aggregate store being used */
		// aggregateStoreParams: false,

		/** @property {IAggregateStoreResponse} aggregateStoreResponse - response from query for aggregate store */
		// aggregateStoreResponse: null,

		// Boolean: indicate if want display name vs. stored name
		bDisplayName: false,

		// Boolean: indicates if names should be sorted
		bSort: true,

		/** @property {Cache} cachingStore - cache to use to reference nodes or store queried ones */
		cachingStore: null,

		// String: property to use to get css for item (if any)
		cssProperty: CSS_PROPERTY,

		/** @property {boolean} defaultToPriorityOnly - set to true if we only want to consider priority store results when determining default value. */
		//defaultToPriorityOnly: false,

		/** @property {string} defaultValue - default value for store (optional) */
		defaultValue: null,

		/** @property {cnl} emptyValue - value for empty item */
		emptyValue: csi.EMPTY_URL,

		/** @property {string} enumId - if store contains enum values then this will be populated with EnumList name (used in NewPaneForm) */
		enumId: null,

		// function(/*Node*/): optional filter function that is not supported by server filters
		//filterFunc: null,

		// String: property to use to get group for item (if any)
		groupProperty: "group",

		// String: omit item with given id
		//idOmit: null,

		/** @property {boolean} ignoreInvalid - set to true if no items should be classified as invalid */
		ignoreInvalid: false,

		/** @property {boolean} ignoreLocalizedName - don't show localized name even if results inherit LocalizedItem */
		ignoreLocalizedName: false,

		/** @property {boolean} isDelayedSearch - delayed search is configured for attribute using this store */
		//isDelayedSearch: false,

		// String: property to use to get id
		actionProperty: ACTION_PROPERTY,

		// String: property to use to get id
		idProperty: ID_PROPERTY,

		// String: property to use to get URL
		urlProperty: ID_PROPERTY,

		//String: property to get the sorted index
		indexProperty: INDEX_PROPERTY,

		// String: property to use to get displayed name
		labelProperty: NAME_PROPERTY,

		/** @property {string} labelProperty2 - property storing secondary label for item if requested (such as from slim card)  */
		labelProperty2: "name2",

		// String: property for locale
		loc: null,

		// String: property to use to get stored name
		nameProperty: NAME_PROPERTY,

		// String: property to indicate new item
		newProperty: "New",

		/** @property {boolean} omitInvalid - set to true if invalid values should not be added to store */
		omitInvalid: false,

		/** @property {(res: IAggregateStoreResponse) => void} onAggregateStoreResponse - callback function to call once response is known */
		onAggregateStoreResponse: null,

		// Function(item): function to pre-process item returned from request
		//onResultItem: null,

		// Names: store of priority items that will be sorted at the top of the list
		//priorityStore: null,

		/** @property {string} searchProperty - property to use for searching, but only used with aggregate stores */
		searchProperty: null,

		/** @property {Boolean} [treatAsPriority] - store of strictly bold priority items */
		//treatAsPriority: null,

		// String: type of node being returned by request
		//typeNode: null,

		/** @property {boolean} _hasOtherResults - set to true if using old aggregate store architecture and both stores have data of the same node type */
		_hasOtherResults: false,

		/** @property {boolean} _useNewCache - set to true to cache the nodes to new store instead */
		_useNewCache: false,

		constructor: function(/*Object*/options) {
			// summary: if no request given, then store must be loaded
			if (!this.request) {
				this._loaded = true;
			}

			if (this.aggregateStoreParams) {
				this.searchProperty = SEARCH_PROPERTY;
			}

			// ensure internal store has same properties as this one - CheckedMultiSelectDropdown uses internal store in some cases for querying
			const {labelProperty, labelProperty2, searchProperty, _store} = this;
			_store.labelProperty = labelProperty;
			_store.labelProperty2 = labelProperty2;
			_store.searchProperty = searchProperty;
		},

		/**
		 * Add the store's current values to it. Organize them so they are ready for the Select components
		 * @param {NamesResult[]} storeOptionsData
		 */
		addCurrentValues(storeOptionsData) {
			const {idProperty} = this;
			const isStoreLoaded = this.isLoaded();

			storeOptionsData = storeOptionsData || [];

			// if store already queried, then remove items from store that were added because they were the current value;
			// if they were not part of the result set, then they must no longer be valid
			if (isStoreLoaded) {
				this.query({[INVALID_PROPERTY]: true}).forEach((item) => this.remove(item[idProperty]));
			}

			// make sure the current value or values are in store so they don't have to be queried
			if (isStoreLoaded) {
				this._organizeDropDownData(storeOptionsData, this._store.data);
			} else {
				const itemsToPushToStore = storeOptionsData.filter((item => !this.getFromMemory(item[idProperty])));
				itemsToPushToStore.forEach((item) => this.put(item));
			}
		},

		/**
		 * Return default value for store if there is only one valid value; otherwise return the first value (which is the empty value)
		 * @param {Record<string, any>} options
		 * @param {boolean} [defaultToFirst] - if true, then return first item even if there are multiple valid items in store
		 * @return {Promise<string>}
		 */
		getDefaultValue(options, defaultToFirst) {
			const {defaultValue, idProperty} = this;

			if (defaultValue) {
				return when(this.get(defaultValue), (result) => result[idProperty]);
			}

			// query for first 10 even though only looking for one - it is possible there are empty groups, so want to be sure
			// to get enough valid results. There will only be a few groups, so 10 should cover it.
			options = options || {};
			options.start = 0;
			options.count = 10;
			options.noActionData = true;

			return when(this.query({}, options), (results) => {
				const validResults = results.filter((item) => !item[DISABLED_PROPERTY] && !item[INVALID_PROPERTY]);
				const {length} = validResults;

				if (!length) {
					return null;
				}

				// if only one valid or suggested result, then return it;
				// if there is an empty item, then it is the default;
				// otherwise there is no default since there are either no results, or more than one valid result
				let defaultItem = this._getEmptyItem();
				const nOne = defaultItem ? 2 : 1;

				const hasValidResults = (length === nOne) && (!this.defaultToPriorityOnly || validResults[nOne - 1].priority);
				const hasPriorityResults = (length > nOne) && validResults[nOne - 1].priority && !validResults[nOne].priority;
				if (hasValidResults || hasPriorityResults) {
					defaultItem = validResults[nOne - 1];
				}

				// if no default/empty item and more than one valid result, then return first if so desired
				if (!defaultItem && defaultToFirst) {
					defaultItem = validResults[0];
				}

				return defaultItem?.[idProperty];
			});
		},

		/**
		 * @override
		 * Return empty value configured for store
		 */
		getEmptyValue() {
			// TODO: rework when we have string selection aggregate stores
			return (this.idProperty == this.labelProperty) ? "" : this.emptyValue;
		},

		/**
		 * Return query object to use to identify non-empty values
		 * @return {Record<string, any>}
		 */
		getNonEmptyQuery() {
			const {emptyValue} = this;
			return {
				[ID_PROPERTY]: {
					test: (value, item) => value != emptyValue
				}
			};
		},

		/**
		 * Return true if store has no items to select - if there are no items or all items are disabled
		 * @return {boolean}
		 */
		isStoreEmpty() {
			return this._isEmptyOrDisabled(this._store.data);
		},

		put: function(object, options) {
			// summary: re-sort after adding new item, making sure empty item is first
			var id = this._store.put(object, options);
			var data = this._store.data;

			// rebuild index if data needs to be sorted; don't sort if options.before === null
			if (this._needToSort(data) && (options?.before !== null)) {
				data = this._sort(data);
				this._store.setData(data);
			}

			return id;
		},

		/**
		 * Return number of items in the store (including any empty one)
		 * @return {number}
		 */
		size() {
			return this._store.data.length;
		},

		/**
		 * Create a map of the store data array, with the item id as the key. Add the empty item id to it if available.
		 * @param {NamesResult[]} data
		 * @return {Record<string, boolean>}
		 */
		_getItemsMap(data) {
			const {idProperty} = this;
			const emptyItem = this._getEmptyItem();
			const itemMap = csi.hashArray(data, idProperty, Boolean);

			if (emptyItem) {
				itemMap[emptyItem[idProperty]] = true;
			}

			return itemMap;
		},

		/**
		 * Return an array containing the empty item, if available.
		 * @return {NamesResult[]}
		 */
		_getEmptyItemSegment() {
			const emptyItem = this._getEmptyItem();
			return emptyItem ? [emptyItem] : [];
		},

		/**
		 * Return an array containing a list of items considered invalid in a store data array.
		 * @param {NamesResult[]} items
		 * @param {Record<string, boolean>} itemMap
		 * @return {NamesResult[]}
		 */
		_getInvalidItemsSegment(items, itemMap) {
			const {idProperty, ignoreInvalid, isDelayedSearch, omitInvalid} = this;
			if (omitInvalid) {
				return [];
			}

			const invalidItems = items ? items.filter((item) => !itemMap[item[idProperty]]) : [];
			if (invalidItems.length) {
				// when using delayed search, we cannot track invalid items as we don't have all the data
				if (!isDelayedSearch && !ignoreInvalid) {
					invalidItems.forEach(invalidItem => {
						invalidItem[INVALID_PROPERTY] = true;
					});
				}

				this._sort(invalidItems);
			}

			return invalidItems;
		},

		/**
		 * Return an array containing a list of items considered valid in a store data array. Exclude the empty item as well.
		 * @param {NamesResult[]} items
		 * @param {Record<string, boolean>} itemMap
		 * @return {NamesResult[]}
		 */
		_getValidItemsSegment(items, itemMap) {
			const {idProperty} = this;
			const emptyItem = this._getEmptyItem();
			const emptyItemValue = emptyItem?.[idProperty];
			return items.filter(({[idProperty]: itemId}) => (itemMap[itemId] && (itemId !== emptyItemValue)));
		},

		/**
		 * Organize the provided store data in an array ready to be used by a drop-down component.
		 * @param {NamesResult[]} currentData - Existing store data, or if an aggregate store, current data coming from the response.
		 * @param {NamesResult[]} incomingData - New or already selected items
		 */
		_organizeDropDownData(currentData, incomingData) {
			const {idProperty, indexProperty} = this;
			const itemMap = this._getItemsMap(incomingData, idProperty);
			const emptyItemSegment = this._getEmptyItemSegment();
			const invalidItemsSegment = this._getInvalidItemsSegment(currentData, itemMap);
			const validItemsSegment = this._getValidItemsSegment(incomingData, itemMap);
			const data = [...emptyItemSegment, ...invalidItemsSegment, ...validItemsSegment];

			// add sort index to keep track of original loaded Sorted Order
			if (indexProperty) {
				assignItemIndex(data, indexProperty);
			}

			this._store.setData(data);
		},

		// RequestStore api

		_onResponse: function(/*Response*/res, /*Request*/req, /*Object*/options) {
			// summary: set store data for given response
			const {
				actionData,
				aggregateStoreParams,
				cachingStore,
				cssProperty,
				emptyValue,
				groupProperty,
				idOmit,
				idProperty,
				ignoreInvalid,
				labelProperty,
				onAggregateStoreResponse,
				onResultItem,
				priorityStore,
				treatAsPriority,
				typeNode,
				_store,
				_useNewCache
			} = this;

			const emptyItem = this._getEmptyItem();
			const emptyGroupAllItem = createEmptyGroupItem(GROUP_ALL_ITEMS);
			const emptyGroupSuggestedItem = createEmptyGroupItem(GROUP_SUGGESTED);
			let hasData = false;

			if (aggregateStoreParams) {
				// properties no longer needed with aggregate store
				//	- bDisplayName
				//	- bSort
				//	- customOperation
				//	- filterFunc
				//	- idOmit
				//	- ignoreLocalizedName - may need to be option on QueryAggregateStore operation
				//	- onResultItem
				//	- priorityStore
				//	- translate?
				//	- treatAsPriority
				//	- _processResultNode
				//	- _useNewCache

				// convert aggregate store response to data for store
				const {currentValues, groups, requireText} = res;
				const isDelayedRequest = !!requireText && !aggregateStoreParams.searchText;
				const items = getNamesFromAggregateStoreResponse(res, !isDelayedRequest);

				// Organize the store data so it's prepared for drop-down display.
				// TODO - what to do with current value keys?
				const currentItems = mapResultsToGroupItems(res, currentValues || []);
				this._organizeDropDownData(currentItems, items);

				// enable grouping
				// TODO - may need to base on number of groups and if suggested
				this.treatAsPriority = true;
				this.aggregateStoreResponse = res;
				this.aggregateGroupIndexMap = csi.hashArray(groups, "groupId", Number);

				// if empty, then remove Go to Dialog option; disregard if response does not include all data (requireText is true)
				const type = getAggregateResponseNodeType(res);
				const allowGoToDialog = !type || reflection.isGoToDialogAvailableForType(type);

				if (actionData && !requireText && (isAggregateStoreResponseEmpty(res) || !allowGoToDialog)) {
					this.actionData = actionData.filter((item) => item.$ !== csi.DIALOG_URL);
				}

				onAggregateStoreResponse?.(res);

				return;
			}

			const sdata = !this.isLoaded() && _store.data;
			var data = res.getNameAndUrls();
			var dfd;
			var i;

			if (priorityStore) {
				if (!emptyItem) {
					priorityStore.remove(emptyValue);
				}
				dfd = priorityStore.query(null, (options && options.sync) ? {sync: true} : null);
			}

			if (!data) {
				// create data from ResultNodes if no URLs
				let cache = cachingStore;

				if (!cache || _useNewCache) {
					cache = new StoreCache();
				}

				cache.cacheResponse(res);

				data = csi.transform(res.getResultNodes(), function(node) {
					return this._processResultNode(node, cache);
				}, this) || [];
			}

			var n = data.length;
			if (n) {
				hasData = true;

				// post-process results
				data.forEach((item) => {
					item[cssProperty] = getNamesResultItemCss();
					onResultItem?.(item, this);
				});

				// if using name for id (as is the case for Format="Selection"), then guarantee uniqueness
				if (idProperty === NAME_PROPERTY) {
					data = _.uniqBy(data, idProperty);
				}

				// make sure nodes with no name show with localized empty name when storing url
				if (idProperty !== labelProperty) {
					const s = locale.getEmptyName();

					for (i = 0; i < n; i++) {
						if (!data[i][labelProperty]) {
							data[i][labelProperty] = s;
						}
					}
				}

				// sort by label
				if (this.bSort) {
					data = csi.sort(data, labelProperty);
				}
			} else if (!ignoreInvalid || !sdata?.length) {
				// existing data in the store (sdata) will be added to the "All" group if ignoreInvalid is set, so in that
				// case it will not be empty
				data = [emptyGroupAllItem];
			}

			when(dfd, (results) => {
				if (results?.length) {
					// if a priority store is present, then place those items at the front of the list
					if (priorityStore.isStoreEmpty()) {
						results = [emptyGroupSuggestedItem];
					} else {
						// set all priority items to be in the Suggested group
						let hasSuggested = false;

						results.forEach((item) => {
							if (item.$ != emptyValue) {
								item[groupProperty] = item[groupProperty] || GROUP_SUGGESTED;
								item.priority = true;
								hasSuggested = true;
							}
						});

						// remove priority items from response data
						if (hasSuggested) {
							hasData = true;

							data = _.filter(data, function(item) {
								return !priorityStore.get(item[idProperty]);
							});
						} else {
							// add empty entry for suggested group
							results.push(emptyGroupSuggestedItem);
						}
					}

					// set all existing items to be in the All group
					let hasOtherData = false;
					let count = 3;

					data.forEach((item) => {
						if (item.$ != emptyValue) {
							const group = item[groupProperty] || GROUP_ALL_ITEMS;
							item[groupProperty] = group;
							hasOtherData = true;
							GROUP_INDEX_MAP[group] = GROUP_INDEX_MAP[group] || count++;
						}
					});

					if (!hasOtherData) {
						// add empty entry for other group
						data.push(emptyGroupAllItem);
					}

					// priority items are placed at top of list
					data = results.concat(data);
				} else if (treatAsPriority && !priorityStore) {
					data.forEach((item) => {
						if (item.$ != emptyValue) {
							item[groupProperty] = item[groupProperty] || GROUP_SUGGESTED;
							item.priority = true;
						}
					});
				}

				// track whether the priority store has results of the same type as this store
				this._hasOtherResults = !!priorityStore && (typeNode === priorityStore.typeNode);

				// organize the store data so it's prepared for drop-down display.
				this._organizeDropDownData(sdata, data);

				// remove Go to Dialog option if no data
				if (!hasData && this.actionData) {
					this.actionData = this.actionData.filter((item) => item.$ !== csi.DIALOG_URL);
				}

				// remove purposely omitted item
				// FIX - this may prevent caching of this store (use case is calendar activity predecessors)
				if (idOmit) {
					this.remove(idOmit);
				}
			});

			return dfd;
		},

		_onStoreOptions: function(/*Object*/options) {
			// summary: extension point to update store options with additional properties
			const {
				bSort,
				ignoreLocalizedName,
				request,
				typeNode
			} = options;

			if (options.data && (bSort !== false)) {
				options.data = this._sort(options.data);
			}

			if (request?.addParameter) {
				// add locale to search if looking for LocalizedItems
				var rc = reflection.getClass(typeNode);
				if (rc && rc.isLocalizedItem && !ignoreLocalizedName) {
					request.addParameter("Qry.Value.Locale", locale.getLocale());
				}

				// determine if names of this type are resolved by client - if so, then switch to using
				// custom operation to determine display names
				var dnr = typeNode && locale.getDisplayNameResolver(typeNode);
				var displayFormatAttributes = (typeNode && !dnr) ? locale.getDisplayFormatAttributeList(typeNode, ignoreLocalizedName) : [];

				if (dnr || displayFormatAttributes.length) {
					options.bDisplayName = true;
				}

				if (options.bDisplayName && (options.customOperation == null)) {
					options.customOperation = true;
					this._useNewCache = true;

					// should only need values to generate names
					request.addParameter("Fmt.Node.Info", "Min");
					request.addParameter("Fmt.Attr.Info", "Min");
					request.addParameter("Fmt.AC.Rights", "No");

					// query for only two attributes if display format and does not have display name resolver
					for (const attrs of displayFormatAttributes) {
						request.addParameter("Fmt.Attr.List", attrs, true);
					}
				}

				// use NamesByXML if not doing custom operation
				if (!options.customOperation) {
					request.addParameter(comm.MODULE, comm.MOD_SEARCH);
					request.addParameter(comm.OPERATION, this.requestOperation);
				}

				request.mixinParameters(options.requestParameters);

			} else if (Array.isArray(options.data)) {
				// populate index for each item
				options.data.forEach((item, i) => {
					item[INDEX_PROPERTY] = i;
				});
			}
		},

		_doQuery: function(query, options) {
			// summary: add actionData item to results - if count is specified, then subtract number of actions
			// so that total will be the same once actions are added
			const internal = !!options?.noActionData;
			const ad = this.actionData;
			let c;
			let s;

			if (ad && options && !internal) {
				if (c = options.count) {
					// if paging, then do so according to page size minus the number of actions - actions will be added afterwards
					s = options.start;
					options.start -= (s / c) * ad.length;
					options.count -= ad.length;
				}
			}

			const {aggregateStoreResponse, groupProperty, typeNode, _hasOtherResults} = this;
			const shouldGroupItems = this.hasPriorityItems() && (!aggregateStoreResponse || isAggregateStoreResponseGrouped(aggregateStoreResponse));

			if (shouldGroupItems && !internal) {
				this._store.queryEngine = GroupQueryEngine;

				options = options || {};
				options.store = options.store || this;
				const optionsGroup = options.group = options.group || {};

				optionsGroup.id = optionsGroup.id || ((item) => item[groupProperty] || "");

				optionsGroup.isSuggestedFunc = optionsGroup.isSuggestedFunc || ((id) => aggregateStoreResponse ?
					!!getAggregateResponseGroupById(aggregateStoreResponse, id)?.suggested :
					false
				);

				optionsGroup.nameFunc = optionsGroup.nameFunc || ((id) => aggregateStoreResponse ?
					getLocalizedGroupLabel(getAggregateResponseGroupById(aggregateStoreResponse, id)) :
					getLocalizedGroupLabelOld(id, typeNode, typeNode && (id === GROUP_ALL_ITEMS), _hasOtherResults)
				);

				optionsGroup.sortFunc = optionsGroup.sortFunc || ((id) => this._getGroupIndex(id));
			}

			// DOJO INTERNAL: override Memory.query so we can pre-filter if needed - this must
			// be done at each query to support reuse of store, rather than filtering the results
			// immediately after the request

			let {data} = this._store;

			if (this.filterFunc) {
				data = _.filter(data, this.filterFunc);
			}

			// filter our empty group items which are not real item, but rather special placeholder C8-49913
			if (internal) {
				data = data.filter(item => !item[EMPTY_GROUP_ITEM_PROPERTY]);
			}

			if (options) {
				options.cssProperty = options?.cssProperty || this.cssProperty;
			}

			let results = QueryResults(this._store.queryEngine(query, options)(data));

			// Create "No Results" disabled item to indicate that user search made it empty
			if (this._isEmpty(results) && !internal) {
				const noResultsItem = results.filter(e => e[EMPTY_GROUP_ITEM_PROPERTY]);
				if (!noResultsItem.length) {
					results = results.concat([createEmptyGroupItem(GROUP_ALL_ITEMS)]);
				}
			}

			// add actions to results
			if (ad && !internal) {
				const t = results.total;

				results = results.concat(ad);

				// if action data exists, assign property to each item indicating so - need to do this each query as it can be reset after store exists
				_.each(ad, (item) => {
					item[this.actionProperty] = true;
				});

				if (c) {
					// add # of pages * # of actions to total
					results.total = t + ad.length * Math.ceil(t / options.count);

					// restore original start and count options
					options.start = s;
					options.count = c;
				} else {
					// add # of actions to total
					results.total = t + ad.length;
				}
			}

			return results;
		},

		_getEmptyItem: function(/*Object[]?*/data) {
			// summary: return empty item if stored in data
			const d = data || this._store.data;
			if (!d || (d.length === 0)) {
				return null;
			}
			// empty item may be first or second data item (first item might be selected value C8-68448)
			const items = [d[0]];
			if (d.length > 1) {
				items.push(d[1]);
			}
			const emptyItems = items.filter(item=>item.$ === this.emptyValue);
			return emptyItems.length > 0 ? emptyItems[0] : null;
		},

		/**
		 * Return index of given group used for sorting
		 * @param {string} groupId
		 * @return {number}
		 */
		_getGroupIndex(groupId) {
			const map = this.aggregateGroupIndexMap || GROUP_INDEX_MAP;
			return map[groupId] || GROUP_INDEX_OTHER;
		},

		/**
		 * Return true if store has priority items (to be grouped)
		 * @return {boolean}
		 */
		hasPriorityItems() {
			return !this.bSimpleQueryEngine && (this.priorityStore || this.treatAsPriority);
		},

		/**
		 * Return true if number of items in store is 0
		 * @param {NamesResult[]} items
		 * @return {boolean}
		 */
		_isEmpty(items) {
			const {emptyValue} = this;
			return items.every((item) => (item.$ === emptyValue));
		},

		/**
		 * Return true if number of enabled items in store is 0
		 * @param {NamesResult[]} items
		 * @return {boolean}
		 */
		_isEmptyOrDisabled(items) {
			const {emptyValue} = this;
			return items.every((item) => (item.$ === emptyValue) || item[DISABLED_PROPERTY]);
		},

		_processResultNode: function(/*Node*/node, /*Cache*/cache) {
			// summary: convert node into store item
			var item = {$: node.$URL, Name: node.$Name, node: node};

			if (this.translate)
				item.Name = this.translate(node);
			else if (this.bDisplayName)
				item.Name = locale.getNodeConfiguredName(node, cache, this.loc);

			return item;
		},

		_needToSort: function(/*Object[]*/data) {
			// summary: returns true if the data needs to be sorted
			return this.bSort && (data.length > 1);
		},

		_sort: function(/*Object[]*/data) {
			// summary: sort existing data - account for empty items
			if (data.length > 1) {
				const {emptyValue} = this;
				var emptyName = locale.getEmptyName();
				var lid = this.labelProperty;

				data = csi.sort(data, function(item) {
					if (item.$ == emptyValue) return "";
					if (item[lid] == emptyName) return " ";
					return item[lid];
				});
			}

			return data;
		}
	});

	_Names.createFromNodes = function(/*Node[]*/nodes, /*Object*/params) {
		// summary: create Names store from list of nodes
		var data = _.map(nodes, csiStore.nameObject);
		params = Object.assign({data: data}, params);
		return new _Names(params);
	};

	_Names.createFromType = function(/*String*/type, /*Object*/params) {
		// summary: create Names store by querying for given type
		params = params || {};
		params.request = csiStore.searchByType(type).getRequest();
		return new _Names(params);
	};

	/**
	 * Create item to be used in store
	 * @param {string} url
	 * @param {string} name
	 * @return {Object}
	 */
	_Names.nameObject = (url, name) => ({
		[ID_PROPERTY]: url,
		[NAME_PROPERTY]: name,
	});

	_Names.ACTION_PROPERTY = ACTION_PROPERTY;
	_Names.ID_PROPERTY = ID_PROPERTY;
	_Names.INDEX_PROPERTY = INDEX_PROPERTY;
	_Names.NAME_PROPERTY = NAME_PROPERTY;

	return _Names;
});
